import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/contexts/I18nContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import HomePage from "@/pages/HomePage";
import ArtworkDetailPage from "@/pages/ArtworkDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AuthCallback from "@/pages/AuthCallback";
import SellPage from "@/pages/SellPage";
import ArtistDashboard from "@/pages/ArtistDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ArtistPublicPage from "@/pages/ArtistPublicPage";
import ReferrerDashboard from "@/pages/ReferrerDashboard";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import WorkshopsPage from "@/pages/WorkshopsPage";
import api from "@/lib/api";
import { useEffect } from "react";

function ReferralCatcher() {
  // Detect ?ref=user_xxx query param, register click + set cookie via backend, then strip param
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      api.post("/referral/track", { ref }).catch(() => {}).finally(() => {
        params.delete("ref");
        const newSearch = params.toString();
        const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "") + window.location.hash;
        window.history.replaceState({}, "", newUrl);
      });
    }
  }, []);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Catch OAuth callback in URL fragment synchronously, before any other route
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/artwork/:id" element={<ArtworkDetailPage />} />
      <Route path="/artists/:id" element={<ArtistPublicPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/sell" element={<SellPage />} />
      <Route path="/talleres" element={<WorkshopsPage />} />
      <Route path="/dashboard" element={<AuthCallback />} />
      <Route path="/artist/*" element={<ArtistDashboard />} />
      <Route path="/admin/*" element={<AdminDashboard />} />
      <Route path="/referrer/*" element={<ReferrerDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <ReferralCatcher />
              <Toaster position="top-right" richColors />
              <AppRouter />
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
